// Brand-name titles are plain strings shared by both languages; generic
// accessories carry a { ka, en } object instead.
export default function productTitle(product, language) {
    return typeof product.title === 'string' ? product.title : product.title[language];
};
